import { FC, React, useState } from 'external/react'
import { InputStyles } from './styles'

type SelectFieldProps = {
    onChange: (value: string) => void,
    label: string
    required?: boolean,
    value?: string, 
    readonly?: boolean
}

export const InputField: FC<SelectFieldProps> = ({ onChange, label, required, value, readonly }) => {
    return (
        <div style={{display: 'flex', justifyContent: 'center', height: '80px', gap: '8px', flexDirection: 'column', flex: 1}}>
            <div >
                {required && <span style={{color: 'red'}}>*</span>}
                <label style={{height: '60px'}}>
                    {label}
                </label>
            </div>
            <div style={{flex: 1, display: 'flex'}}>
                <input value={value} readOnly={readonly} type='text' onChange={(e) => onChange(e.target.value)} style={{...InputStyles, backgroundColor: readonly ? 'rgba(0,0,0, 0.06)' : undefined, border: readonly ? '1px solid rgba(0,0,0, 0.5)' : undefined}}/>
            </div>
        </div>
    )
}